export const LANDING = '/';
export const PROJECT = '/project';
